import React from 'react';
import Context from './context';
import useStorage from '../../utils/useStorage';

const StoreProvider = ({ children }) => {
  const [token, setToken, removeToken] = useStorage('token');
  const [pk_user, setPKUser, removePKUser] = useStorage('pk_user');
  const [pk_service, setPKService, removePKService] = useStorage('pk_service');
  const [displayName, setDisplayName, removeDisplayName] = useStorage('displayName');
  const [givenName, setGivenName, removeGivenName] = useStorage('givenName');
  const [racf, setRACF, removeRACF] = useStorage('racf');

  return (
    <Context.Provider
      value={{
        token,
        setToken,
        removeToken,
        pk_user,
        setPKUser,
        removePKUser,
        pk_service,
        setPKService,
        removePKService,
        displayName,
        setDisplayName,
        removeDisplayName,
        givenName,
        setGivenName,
        removeGivenName,
        racf,
        setRACF,
        removeRACF,
      }}
    >
      {children}
    </Context.Provider>
  )
}

export default StoreProvider;